import { BaseModule as CoreBaseModule } from "core/controller/Module"
import { appName } from "../AppName"

export abstract class BaseModule extends CoreBaseModule {
  static appName: string = appName
  get appName() {
    return BaseModule.appName
  }
}
